import { render, staticRenderFns } from "./comment_detail.vue?vue&type=template&id=15b19f7a&scoped=true&"
import script from "./comment_detail.vue?vue&type=script&lang=js&"
export * from "./comment_detail.vue?vue&type=script&lang=js&"
import style0 from "./comment_detail.vue?vue&type=style&index=0&id=15b19f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b19f7a",
  null
  
)

export default component.exports